import {
  donationInfoSchema,
  DonationInfoSchemaType,
} from 'modules/donations/components/DonationInfoSection/schema';
import {
  environmentSchema,
  EnvironmentSchemaType,
} from 'modules/donations/components/EnvironmentSection/schema';
import {
  examinationSchema,
  ExaminationSchemaType,
} from 'modules/donations/components/ExaminationSection/schema';
import {
  quantitySchema,
  QuantitySchemaType,
} from 'modules/donations/components/QuantitySection/schema';
import {
  donationDateSchema,
  ineligibleReasonSchema,
} from 'modules/donations/schemas';
import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

const t = getTranslation('donation.UpdateDonationForm.Examination');

type EditDonationSchemaType = {
  examination: ExaminationSchemaType;
  donationInfo: DonationInfoSchemaType;
  environment: EnvironmentSchemaType;
  quantity: QuantitySchemaType;
  donorId: string;
  donationDate: Date;
};

const baseSchema = yup.object({
  donorId: yup.string().max(255).required(),
});

const normalDonationSchema = yup.object({
  examination: examinationSchema,
  donationInfo: donationInfoSchema,
  environment: environmentSchema,
  quantity: quantitySchema,
  donationDate: donationDateSchema,
});

const ineligibleDonationOverride: yup.AnyObjectSchema = yup.object({
  examination: yup.object({
    ineligibleReason: ineligibleReasonSchema,
    ineligibleReasonDetails: yup.string().optional().nullable(),
  }),
});

const editDonationSchema = yup.lazy((values: EditDonationSchemaType) =>
  values?.examination?.ineligible
    ? baseSchema.concat(ineligibleDonationOverride)
    : baseSchema.concat(normalDonationSchema)
);

export { editDonationSchema };
export type { EditDonationSchemaType };
